import type { FC } from 'react';
import { CutdownCard } from '@/components/CutdownCard';
import type { CutdownCardBlock } from '@/components/canvas/blocks/types';
import { BlockHostView } from '@/components/canvas/blocks/BlockHostView';
import type { BlockViewProps } from '@/components/canvas/blocks/registry/types';
import { cutdownCardPropsFromBlockData } from '@/components/canvas/blocks/cutdown-card/mapBlockStyles';
import { estimateCutdownCardContentSize } from '@/components/canvas/blocks/cutdown-card/contentMetrics';

export const CutdownCardBlockView: FC<BlockViewProps<CutdownCardBlock>> = ({
  block,
  displayLayout,
  onPointerDown,
  isPresentationMode,
}) => {
  const { data } = block;
  const cardProps = cutdownCardPropsFromBlockData(data);
  const { scale: dataScale, ...cardPropsWithoutScale } = cardProps;
  const contentSize = estimateCutdownCardContentSize(data);

  return (
    <BlockHostView
      block={block}
      displayLayout={displayLayout}
      contentSize={contentSize}
      contentScale={dataScale ?? 1}
      onPointerDown={
        onPointerDown ? (e) => onPointerDown(e, block) : undefined
      }
      isPresentationMode={isPresentationMode}
    >
      <CutdownCard {...cardPropsWithoutScale} scale={1} />
    </BlockHostView>
  );
};
